export default {

	data: function() {

		return {
			is: {
                loading: true,
                loaded: false
			}
		}

    },
    
    computed: {

        path: function() {

            return this.$route.meta.page || this.$route.params.slug

        }

    },
    
    watch: {

        path: function() {

            if (this.is.loaded) this.load()

        }

    },

	created: function() {

		this.load()

	},

	methods: {

		load: function(data) {

			data = data || {}

            data.page = this.$route.meta.page || this.$route.params.slug
            data.slug = this.$route.params.slug

			this.is.loading = true
			this.is.loaded = false

			this.$store.commit('page/set', {})

			return new Promise(function(resolve, reject) {

				this.$api.request('page', data).then(function(json) {

					this.$store.commit('page/set', json.page);

                    this.is.loading = false
                    this.is.loaded = true

					resolve(json)

				}.bind(this), function(e) {

					this.$router.push({ name: '404' })

					reject(e)

				}.bind(this))

			}.bind(this))

		}

	}

}